const CONF_INIT = 'CONF_INIT' //配置信息


export default {
    state: JSON.parse(sessionStorage.getItem('conf')) || {},
    mutations: {
        [CONF_INIT](state, conf) {
            sessionStorage.setItem('conf', JSON.stringify(conf))
            Object.assign(state, conf)
        }
    },
    actions: {
        [CONF_INIT]({commit}, conf) {
            commit(CONF_INIT, conf)
        }

    }
}



// WEBPACK FOOTER //
// ./src/store/conf.js